import {SecondaryButton} from "../buttons/SecondaryButton";
import AddIcon from "@mui/icons-material/Add";
import {StringListDialog} from "../dialogs/StringListDialog";
import React, {useCallback, useState} from "react";
import {useWatch} from "react-hook-form";

export function MuiRhfStringListDialogField(props: {
  name: string,
  title: string,
  inputLabel: string,
  disabled?: boolean
}) {
  const {name, title, inputLabel, disabled} = props;
  const [showRedirectUrisDialog, setShowRedirectUrisDialog] = useState(false);
  const valueWatch = useWatch({name: name});

  const closeRedirectUrisDialog = useCallback((event?: {}, reason?: 'backdropClick' | 'escapeKeyDown') => {
    setShowRedirectUrisDialog(false);
  }, []);

  const buttonLabel = title + " (" + (valueWatch?.length || 0) + ")";

  return (
    <>
      <SecondaryButton title={buttonLabel}
                       variant={disabled ? 'text' : 'outlined'}
                       onClick={() => {
                         setShowRedirectUrisDialog(true);
                       }}
                       startIcon={disabled ? <></> : <AddIcon/>}
                       fullWidth={true}
      />
      <StringListDialog name={name}
                        inputLabel={inputLabel}
                        title={title}
                        open={showRedirectUrisDialog} handleClose={closeRedirectUrisDialog}
                        disabled={disabled}/>
    </>
  )
}
